import React from "react";
import { Box, Link } from "@mui/material";
import { ClickEventType } from "../../../types";
import { customEvent } from "../../../utils";
import { useIsChuseokCallOff } from "../../../hooks/useChuseokOff";

export function FullWidthButton({
  backgroundColor,
  text,
  href,
  event,
  onClick,
  isGoiCall,
}: {
  backgroundColor?: string;
  text: string;
  href?: string;
  event?: ClickEventType;
  onClick?: () => void;
  /**
   * 이 버튼이 고이 대표번호로 거는 콜인지.
   * href 가 tel: 이면 자동으로 알지만, onClick 안에서 call() 을 부르는 형태는
   * 컴포넌트가 알 수 없어 호출부가 알려준다.
   */
  isGoiCall?: boolean;
}) {
  /**
   * 2026 추석. 장지, 화장장 경로에서 tel: 버튼은 통째로 내린다.
   * 이 컴포넌트는 홈과 혜택 인덱스에서도 쓰이는데 그쪽은 경로 조건에서 빠져 그대로 남는다.
   */
  const isChuseokCallOff = useIsChuseokCallOff();
  const isGoiCallButton = isGoiCall || Boolean(href?.startsWith("tel:"));

  const onClickLink = () => {
    if (event) {
      customEvent(event);
    }

    if (onClick) {
      onClick();
    }
  };

  if (isGoiCallButton && isChuseokCallOff) return null;

  return (
    <Link
      href={href}
      style={{
        background: backgroundColor || "",
        border: backgroundColor ? "" : "1px solid #8f8f8f",
        padding: "16px",
        color: backgroundColor ? "white" : "#252525",
        borderRadius: "8px",
        textDecoration: "none",
        textAlign: "center",
        // href 없이 onClick 만 넘기는 경우(모달 등)에도 버튼으로 보이게 한다
        cursor: "pointer",
      }}
      onClick={onClickLink}
    >
      <Box className="subtitle_16_b">{text}</Box>
    </Link>
  );
}
